import InputField from "../../InputField/InputField";
import { HeadingTitle } from "../ModalContainer";
import vectorUploadIcon from "../../../Assets/Icons/Vector.png";
import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";
import { useCallback, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useSpring, animated } from "react-spring";
import axios from "axios";
import Loader from "../../Loading/Loading";
import { BASEURI } from "../../../Middleware/axiosInstance";

const AddComment = ({ title, close, order_id }) => {
  const [comment, setComment] = useState("");
  const [files, setFiles] = useState([]);
  const [filePreviews, setFilePreviews] = useState([]);
  const [showPreview, setshowPreview] = useState(false);
  const [loading, setLoading] = useState(false);

  const baseDomain = BASEURI.split("/")[0] + "//" + BASEURI.split("/")[2];

  // Dropzone code
  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length === 0) {
        toast.error("No files selected.");
        return;
      }

      // Add files to the state
      const newFiles = [...files, ...acceptedFiles];
      setFiles(newFiles);

      // Create previews for each file
      const newPreviews = newFiles.map((file) => URL.createObjectURL(file));
      setFilePreviews(newPreviews);
      setshowPreview(true);
    },
    [files]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const previewInAnimation = useSpring({
    opacity: showPreview ? 1 : 0,
    transform: showPreview ? "scale(1)" : "scale(0)",
    config: { duration: 10 },
  });

  const handleChange = (value) => {
    setComment(value);
  };

  const handleSubmit = async () => {
    try {
      if (!comment) {
        toast.error("Please enter the comment.");
        return;
      }
      if (files.length === 0) {
        toast.error("Please select at least one image.");
        return;
      }

      setLoading(true);
      const formData = new FormData();

      // Append all files
      files.forEach((file, index) => {
        formData.append(`images[${index}]`, file);
      });

      formData.append("comment", comment);

      const { data } = await axios.post(
        `${baseDomain}/ManufactureOrders/ajaxAddComment/${order_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (data.status === 1) {
        toast.success("Submitted Successfully");
      } else {
        toast.error(data?.msg);
      }
      setLoading(false);
      close();
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <div>
      <HeadingTitle title={title} center={false} closeModal={close} />
      <div className="mtx-5">
        <div>
          <InputField
            label={"Comment"}
            placeholder={"Enter comment"}
            onChange={handleChange}
            name={"comment"}
          />
        </div>
      </div>
      <div className="mtx-3 text-center">
        <div className="browse-files" {...getRootProps()}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <>
              <img src={vectorUploadIcon} alt="" />
              <h2 className="upload-tag">Upload Images</h2>
              <p className="drag-tag">
                Drag and Drop files here Or <span>Choose files</span>
              </p>
              <p className="drag-small-tag">
                Support formats: PDF | Minimum size: 5 MB
              </p>
            </>
          ) : (
            <>
              <img src={vectorUploadIcon} alt="" />
              <h2 className="upload-tag">Upload Images</h2>
              <p className="drag-tag">
                Drag and Drop files here Or <span>Choose files</span>
              </p>
              <p className="drag-small-tag">
                Support formats: PDF | Minimum size: 5 MB
              </p>
            </>
          )}
        </div>
      </div>
      {files.length > 0 && (
        <animated.div style={previewInAnimation} className="file-previews">
          {filePreviews.map((preview, index) => (
            <div key={index} className="preview-item">
              <span
                onClick={() => {
                  const newFiles = [...files];
                  const newPreviews = [...filePreviews];
                  newFiles.splice(index, 1);
                  newPreviews.splice(index, 1);
                  setFiles(newFiles);
                  setFilePreviews(newPreviews);
                }}
              >
                <RxCross2 />
              </span>
              <img
                title={files[index]?.name}
                src={preview}
                alt="preview"
                style={{ width: "80px", height: "80px" }}
              />
            </div>
          ))}
        </animated.div>
      )}
      <div className="mt-3 add-conta text-center">
        <button
          className="add-btn"
          disabled={comment === "" || files.length === 0}
          onClick={handleSubmit}
          style={{ backgroundColor: "#3C94C6" }}
        >
          {loading ? (
            <Loader color={"#ffffff"} loading={loading} size={18} />
          ) : (
            "Submit"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddComment;
